import { render, staticRenderFns } from "./Aluminum.vue?vue&type=template&id=22d9623d"
import script from "./Aluminum.vue?vue&type=script&lang=ts"
export * from "./Aluminum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports